
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-date-pickers/custom-layout",
      function () {
        return require("private-next-pages/x/react-date-pickers/custom-layout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-date-pickers/custom-layout"])
      });
    }
  